<template>
  <el-dialog
    title="关联试题"
    :close-on-click-modal="false"
    :visible.sync="outerVisible"
    class="special-dialog"
    width="104.375rem"
  >
    <div class="outerVisible">
      <img src="@/assets/img/car.png" alt="" class="car" />
      <div class="car-count">{{ bucketData.length }}</div>
      <div class="car-text" @click="openModel">试题篮</div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"> </el-tab-pane>
        <el-tab-pane label="单选题" name="radio"> </el-tab-pane>
        <el-tab-pane label="多选题" name="more"> </el-tab-pane>
        <el-tab-pane label="判断题" name="judge"> </el-tab-pane>
      </el-tabs>
      <div class="content-area">
        <el-select
          v-model="courseLevelValue"
          placeholder="请选择试题难度"
          style="margin-bottom: 12px;"
          clearable
          @change="dataGet"
        >
          <el-option
            v-for="item in examLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div
          class="list"
          v-for="(item, index) in quesData"
          :key="item.questionsId"
        >
          <div class="list-style">
            <div class="header-title">
              ({{ getExamLabel(item.courseLevel) }}) {{ index + 1 }}.{{
                item.questionStem
              }}
            </div>
            <div class="bottom-option">
              <div
                class="option"
                v-for="temp in item.qaList"
                :key="temp.answerId"
              >
                {{ temp.answerFLag }} {{ temp.answerStem }}
              </div>
              <div
                class="add-bucket"
                @click="addBasket(item)"
                v-if="!bucketIds.includes(item.questionsId)"
              >
                <span>+ 加入试题篮</span>
              </div>
              <div class="remove-bucket" @click="removeBasket(item)" v-else>
                <span>- 移除试题篮</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="quesTotal"
        :page-size="pageparms.pageSize"
        :current-page.sync="pageparms.pageNum"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>
<script>
import { getExamLabel, examLevel } from "@/utils/dict";

import { getTestPaperList, lookPaperInfo } from "@/api/manage";
export default {
  data() {
    return {
      examLevel,
      bucketData: [],
      activeName: "all",
      outerVisible: false,
      courseLevelValue: "",
      paperData: {},
      quesData: [],
      quesTotal: 0,
      pageparms: {
        pageNum: 1,
        pageSize: 10
      },
      questionType: {
        radio: {
          type: 1,
          title: "单选题",
          bucket: []
        },
        judge: {
          type: 2,
          title: "判断题",
          bucket: []
        },
        more: {
          type: 3,
          title: "多选题",
          bucket: []
        }
      }
    };
  },
  computed: {
    // 判断是否在试题栏中
    bucketIds() {
      return this.bucketData.map(item => item.questionsId);
    }
  },
  methods: {
    getExamLabel,
    // 打开弹框
    async open(row) {
      this.paperData = row;
      this.activeName = "all";
      const res = await lookPaperInfo(row.questionPaperId);
      this.bucketData = res.data.data;
      this.outerVisible = true;
      this.dataGet();
    },
    close() {
      this.outerVisible = false;
    },
    setBucket(data) {
      this.bucketData = data;
    },
    openModel() {
      if (this.bucketData.length != 0) {
        this.$emit("bucketOpen", this.paperData, this.bucketData);
      } else {
        this.$message({
          showClose: true,
          message: "请添加试题",
          type: "error"
        });
      }
    },
    // 获取试题
    async dataGet() {
      const params = { ...this.pageparms };
      params.questionType = this.questionType[this.activeName]
        ? this.questionType[this.activeName].type
        : "";
      params.courseLevel = this.courseLevelValue;
      const res = await getTestPaperList(params);
      this.quesData = res.data.data.rows;
      this.quesTotal = res.data.data.total;
    },
    // 切换类型
    async handleTabClick(tab, event) {
      await this.currentChange(1);
    },
    // 翻页
    async currentChange(val) {
      this.pageparms.pageNum = val;
      await this.dataGet();
    },
    addBasket(item) {
      this.bucketData.push(item);
    },
    removeBasket(item) {
      let index = this.bucketData.findIndex(i => {
        return i.questionsId == item.questionsId;
      });
      this.bucketData.splice(index, 1);
    }
  }
};
</script>
<style lang="less" scoped>
.special-dialog {
  .car {
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    top: 2.3%;
    right: 4%;
    z-index: 9999;
  }

  .car-count {
    position: absolute;
    top: 1%;
    right: 3.5%;
    z-index: 99999;
    background: #1890ff;
    border-radius: 0.625rem;
    // padding: 0.2rem;
    width: 1.25rem;
    height: 1.25rem;
    line-height: 1.25rem;
    text-align: center;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
  }

  .car-text {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #8c95a6;
    position: absolute;
    top: 2.5%;
    right: 1rem;
    z-index: 99999;
    cursor: pointer;
  }

  /deep/ .el-dialog {
    margin: 0 !important;
    margin-left: 15rem !important;
    margin-top: 78px !important;
    height: calc(100vh - 90px);
  }

  /deep/ .el-dialog__body {
    padding: 1.25rem;
    padding-top: 0;
    height: calc(100vh - 184px);
    overflow-y: auto;
  }

  /deep/ .el-dialog__header {
    // padding: 0;
  }

  /deep/ .el-tabs__nav-wrap {
    background: #fafafa;
    box-shadow: 3px 4px 6px 0px rgba(240, 240, 240, 0.63);
    padding-left: 1.6875rem;
    height: 3.25rem;
    line-height: 3.25rem;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background: transparent;
  }

  /deep/ .el-tabs__item {
    font-size: 0.875;
    font-family: PingFangSC-Regular, PingFang SC;
    // font-weight: 500;
    color: #8c95a6;
  }

  .outerVisible {
    height: 100%;
    position: relative;
    // overflow-y: auto;
  }

  .bucket {
    background: burlywood;
    width: 10rem;
    text-align: center;
    cursor: pointer;
  }
}
.content-area {
  // overflow: auto;
  // height: 43rem;
  margin-bottom: 0.5rem;

  .list {
    // display: flex;
    background-color: #fafafa;
    padding: 1.25rem 1.5rem 1.25rem 1.25rem;
    box-sizing: border-box;

    margin-bottom: 1rem;

    .list-style {
      .header-title {
        font-size: 0.875rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #434449;
        margin-bottom: 0.5rem;
      }

      .bottom-option {
        font-size: 0.875rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #434449;
        position: relative;

        .option {
          margin-bottom: 0.5rem;
        }

        .option:last-child {
          margin-bottom: 0;
        }

        .add-bucket {
          height: 2rem;
          background: #1890ff;
          border-radius: 0.1875rem;
          width: 6.25rem;
          line-height: 2rem;
          text-align: center;
          position: absolute;
          bottom: 0;
          right: 0;
          cursor: pointer;

          span {
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #ffffff;
          }
        }

        .remove-bucket {
          height: 2rem;
          background: rgba(45, 140, 240, 0.2);
          border-radius: 0.1875rem;
          width: 6.25rem;
          line-height: 2rem;
          text-align: center;
          position: absolute;
          bottom: 0;
          right: 0;
          cursor: pointer;

          span {
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #2d8cf0;
          }
        }

        .remove-bucket {
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Paper/Theory/QuestionDialog.vue